



















import {Component, Vue} from "vue-property-decorator";

import {apiService} from '../services/api-service';
import MainButton from '@/components/MainButton.vue';


@Component({
  components: {MainButton}
})
export default class OrderError extends Vue {

  created() {
    let paymentID = this.$route.query.paymentId;
    apiService.cancelOrder(paymentID);
  }
}
